/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/02/22
 */

interface ColourShade {
    name: string;
    shade: number;
}

export const toColour = (colOrTheme: string, defaultShade: number): ColourShade => {
    const hasLevel = colOrTheme.match(/^(?<name>.+?)(?:\.(?<shade>\d+))?$/);
    if (!hasLevel?.groups) {
        return {
            name: 'black',
            shade: 500,
        };
    }
    const parsedShade = parseInt(hasLevel.groups['shade']);
    return {
        name: hasLevel.groups['name'],
        shade: !Number.isNaN(parsedShade) ? parsedShade : defaultShade,
    };
};

export const incrementShade = ({ name, shade }: ColourShade): ColourShade => {
    return {
        name,
        shade: Math.min(900, shade + 100),
    };
};

export const colourToStyle = (colour: ColourShade): string => {
    return `${colour.name}.${colour.shade}`;
};

export const getContrastingTextColour = (colour: ColourShade): string => {
    if (['blue', 'violet', 'red'].includes(colour.name)) {
        return 'white';
    } else if (colour.name === 'gray' && colour.shade > 700) {
        return 'white';
    }
    return 'black';
};
